export default __webpack_public_path__ + "static/ibb-logo-square-d2861040caa528764facb533b1e8cb60.svg";